<template>
  <div id="app">
    <nav-bar></nav-bar>
    <router-view/>
    <footer>
      <p>Email : maisoncannoise@gmail.com</p>
      <div class="insta">
        <a href="https://www.instagram.com/maisoncannoise"><img src="/static/insta.png" width="40px"/></a>
      </div>
    </footer>
  </div>
</template>

<script>
import NavBar from './components/NavBar'
export default {
  name: 'App',
  components: {NavBar}
}
</script>

<style>
  @font-face {
    font-family: "MostraNuova";
    src: url("/static/fonts/MostraNuova.ttf");
  }

  @font-face {
    font-family: "MostraNuovaBold";
    src: url("/static/fonts/MostraNuova.ttf");
  }

  p{
    font-family: MostraNuova;
  }

  h2{
    font-family:  MostraNuova;
  }

body {
  background-color: #e6e6e6;
}
.carousel-control-next, .carousel-indicators,
.carousel-control-prev {
  filter: invert(100%);
}

footer {
  background-color: white;
  height: 150px;
  margin-top: 0;
  padding:20px;
  -webkit-box-shadow: 0px 0px 12px 0px rgba(0, 0, 0, 0.50);
  -moz-box-shadow: 0px 0px 12px 0px rgba(0, 0, 0, 0.50);
  box-shadow: 0px 0px 12px 0px rgba(0, 0, 0, 0.50);
  font-size: 25px
}

footer p {
  text-align: center;
}

.insta {
  text-align: center;
}

#app {
  min-height:100%;
  margin:0 auto;
  position:relative;
}
</style>



// WEBPACK FOOTER //
// src/App.vue